export const fromEntries = (entries: Array<[string, any]>) => {
  const obj: { [key: string]: any } = {};
  for (const [key, data] of entries) {
    obj[key] = data;
  }
  return obj;
};

export default fromEntries;
